import { ReactComponent as UploadFileIcon } from 'img/icons/uploader/upload_file.svg';
import { ReactComponent as UploadFolderIcon } from 'img/icons/uploader/upload_folder.svg';
import React from 'react';
import { useSelector } from 'react-redux';
import { getCurrentStorage } from 'reactApp/modules/router/router.selectors';
import { EStorageType } from 'reactApp/modules/storage/storage.types';
import { UploadIcon } from 'reactApp/ui/VKUIIcons';

export const useUploadButtons = ({ onFolderClick, onFileClick, onSelectFromCloud }) => {
    const UPLOAD_OPTIONS = {
        selectFromCloud: {
            id: 'selectFromCloud',
            text: 'Выбрать из облака',
            icon: <UploadIcon width="20" height="20" />,
            onClick: onSelectFromCloud,
        },
        uploadFolder: {
            id: 'uploadFolder',
            text: 'Загрузить папку',
            icon: <UploadFolderIcon width="16" height="16" />,
            onClick: onFolderClick,
        },
        uploadFiles: {
            id: 'uploadFiles',
            text: 'Загрузить файлы',
            icon: <UploadFileIcon width="16" height="16" />,
            onClick: onFileClick,
        },
        uploadFilesToAlbum: {
            id: 'uploadFiles',
            text: 'Добавить фото и видео',
            icon: <UploadFileIcon width="16" height="16" />,
            onClick: onFileClick,
        },
    };

    const storage = useSelector(getCurrentStorage);

    return storage === EStorageType.albums
        ? [UPLOAD_OPTIONS.selectFromCloud, UPLOAD_OPTIONS.uploadFilesToAlbum]
        : [UPLOAD_OPTIONS.uploadFolder, UPLOAD_OPTIONS.uploadFiles];
};
